var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"scrol"},[_c('img',{staticClass:"scrolling",attrs:{"src":require("@/assets/img/top.webp"),"alt":"top","id":"scroll"},on:{"click":function($event){return _vm.animateToTop()}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }